import { render, staticRenderFns } from "./form-cooperation.vue?vue&type=template&id=3ad8a369"
import script from "./form-cooperation.vue?vue&type=script&lang=js"
export * from "./form-cooperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports